import request from "@/plugins/http";




export function userListApi(param) {
    return request.post('/api/user/list', param);
}

export function addUserApi(param) {
    return request.post('/api/user/add', param);
}

export function resetPasswordApi(param) {
    return request.post('/api/user/resetPassword', param);
}



